import { Track, TRACK_ID } from '@hugendubel/tracking_client';
import { WS } from '../ws/WS';
import { OAuthValidationWebResult } from '../ws/result/WsOAuthValidationWebResult';
import { LocationUtil, QueryObject } from '@hugendubel/utils';
import { OAuthAuthCodeWebResult } from '../ws/result/WsOAuthAuthCodeWebResult';
import { Modal } from '@hugendubel/react-basic';
import { openWSApiErrorModal } from '../ui/modal/WSApiErrorModal';
import { TempSessionForFamily } from '../temp-session';
import { OAuthCodeParams, OAuthValidationParams } from '../ws/WSCall-types';
import { Globals } from '../globals';

export const _OAuthService: {
    isValid: (params: OAuthValidationParams) => Promise<OAuthValidationWebResult>;
    authCode: (params: OAuthCodeParams, redirectUri?: string) => Promise<OAuthAuthCodeWebResult>;
} = {} as any;

_OAuthService.isValid = (params): Promise<OAuthValidationWebResult> =>
    WS.oauthinternal.isvalid(params).then(result => {
        const { error, redirectUri } = result;
        if (error) {
            Track.error(TRACK_ID('2020-09-15 11:06:11'), 'Parameter validation for oauth returned error');
            _tryRedirect(redirectUri, { error: error });
        }
        return result;
    });

_OAuthService.authCode = (params, redirectUri?): Promise<OAuthAuthCodeWebResult> =>
    WS.oauthinternal.authcode(params).then(result => {
        const { code } = result;
        _tryRedirect(redirectUri, { code: code });
        return result;
    });

const getAuthCodeAndRedirect = async (params: OAuthValidationParams): Promise<void> => {
    if (Modal.isOpen()) await Modal.close();

    try {
        const isValid = await _OAuthService.isValid(params);
        if (!isValid.error && isValid.clientId) {
            await _OAuthService.authCode({ client_id: isValid.clientId }, isValid.redirectUri);
        }
    } catch (e: any) {
        Track.error(TRACK_ID('2020-09-04 12:43:54'), 'Could not get authCode for oauth: ' + e.message);
        const { redirect_uri } = params;
        _tryRedirect(redirect_uri, { error: 'server_error' });
        Globals.window().setTimeout(() => openWSApiErrorModal({ errMessage: 'general.error.retry' }), 500);
    }
};

export const _tryRedirect = (redirectUri?: string, queryParams?: QueryObject): void => {
    if (redirectUri) {
        TempSessionForFamily.clear();
        LocationUtil.redirect(redirectUri, queryParams);
    } else {
        Track.error(TRACK_ID('2020-09-15 11:07:26'), 'Cannot redirect back for oauth, redirect URI is missing.');
    }
};

export const OAuthService = { getAuthCodeAndRedirect };
